import { Input as MuiInput, Slider as MuiSlider } from '@mui/material';
import Accordion from 'components/Accordion';
import { useTranslation } from 'react-i18next';

export default function AgeFilter({ setFilters, filters, defaultExpanded = false }) {
  const { t } = useTranslation();

  const onInputChange = (e, key) => {
    const value = parseInt(e.target.value, 10);

    if (value >= 0 && value <= 130) {
      setFilters({
        ...filters,
        [key]: value,
      });
    }
  };

  const handleKeyDown = (evt) => {
    if (['e', 'E', '+', '-'].includes(evt.key)) {
      evt.preventDefault();
    }
  };

  return (
    <Accordion title={t('Age')} defaultExpanded={defaultExpanded}>
      <div
        style={{
          display: 'flex',
          gap: 16,
          alignItems: 'center',
          marginBottom: 10,
        }}
      >
        <MuiInput
          type="number"
          onChange={(e) => {
            onInputChange(e, 'startAge');
          }}
          onKeyDown={handleKeyDown}
          value={filters.startAge}
          placeholder={t('From')}
        />
        -
        <MuiInput
          type="number"
          onChange={(e) => {
            onInputChange(e, 'endAge');
          }}
          onKeyDown={handleKeyDown}
          value={filters.endAge}
          placeholder={t('To')}
        />
      </div>

      <MuiSlider
        max={130}
        min={0}
        marks={[
          { value: 0, label: '0' },
          { value: 130, label: '130' },
        ]}
        valueLabelDisplay="auto"
        onChange={(e, v) =>
          setFilters({
            ...filters,
            startAge: v[0],
            endAge: v[1],
          })
        }
        value={[filters.startAge, filters.endAge]}
      />
    </Accordion>
  );
}
